import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { CompanyApi } from '@api/companies.api';
import { DeadlineCotractApi } from '@api/deadlineContract.api';
import { ProblemsApi } from '@api/problems.api';
import { SegmentApi } from '@api/segments.api';
import { MaintenancesApi } from '@core/api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { WarrantyStatus } from '@core/interfaces/warranties';
import { mapId } from '@core/utils/filters-utils';
import { getErrorCode } from '@core/utils/get-error-code';
import { ConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { merge, Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { sentry } from 'sentry';
import { PreviousWarrantyDialogComponent } from './components/previous-warranty-dialog/previous-warranty-dialog.component';
import { DialogCreateMaintenancesService } from './dialog-create-maintenances.service';
var DialogCreateMaintenanceComponent = /** @class */ (function () {
    function DialogCreateMaintenanceComponent(matDialogRef, segmentsApi, problemsApi, companiesApi, deadlineContractApi, maintenancesApi, progressBar, customMessageService, authenticationService, dialogCreateMaintenanceService, matDialog, translateService) {
        var _this = this;
        this.matDialogRef = matDialogRef;
        this.segmentsApi = segmentsApi;
        this.problemsApi = problemsApi;
        this.companiesApi = companiesApi;
        this.deadlineContractApi = deadlineContractApi;
        this.maintenancesApi = maintenancesApi;
        this.progressBar = progressBar;
        this.customMessageService = customMessageService;
        this.authenticationService = authenticationService;
        this.dialogCreateMaintenanceService = dialogCreateMaintenanceService;
        this.matDialog = matDialog;
        this.translateService = translateService;
        this.isLoading = false;
        this.problems = [];
        this.hasCreateWarrantyPermission = this.authenticationService.hasPermission('warranties-create');
        this.hasEditWarrantyPermission = this.authenticationService.hasPermission('warranties-edit');
        this.alreadyShownPreviousWarrantyDialog = false;
        this.firstView = true;
        this.isProblemRequired = this.authenticationService.hasAccountPreference({
            property: 'openMaintenance',
            subProperty: 'featureProblemRequired',
            expectedValue: true,
            defaultIfUndefined: false
        });
        this.maintenanceNumberGeneratorType = this.authenticationService.getAccountPreference({
            property: 'openMaintenance',
            subProperty: 'maintenanceNumberGenerator',
            defaultIfNull: 'sequential'
        });
        this.removeSubscriptions = new Subject();
        this.warrantiesUpdatedHandler = function (event) {
            var warranties = event.detail.warranties;
            _this.maintenanceForm.get('warranties').setValue(warranties);
        };
    }
    DialogCreateMaintenanceComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.maintenanceForm = this.dialogCreateMaintenanceService.createMaintenanceForm({
                    maintenanceNumberGeneratorType: this.maintenanceNumberGeneratorType
                });
                this.subscribeToSegment();
                this.subscribeToProblem();
                this.subscribeToCompany();
                this.subscribeToDeadlineContract();
                this.subscribeToLocationChanges();
                this.subscribeToWarranties();
                window.addEventListener('warrantiesUpdated', this.warrantiesUpdatedHandler);
                this.firstView = false;
                return [2 /*return*/];
            });
        });
    };
    DialogCreateMaintenanceComponent.prototype.shouldContinueWithPreviousWarrantyDialog = function (maintenances) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, dialogRef, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = maintenances || null;
                        dialogRef = this.matDialog.open(PreviousWarrantyDialogComponent, {
                            panelClass: ['previous-warranty-dialog'],
                            width: '553px',
                            height: 'auto',
                            disableClose: true,
                            data: data
                        });
                        return [4 /*yield*/, dialogRef.afterClosed().toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result ? result.selectedMaintenanceId : null];
                }
            });
        });
    };
    DialogCreateMaintenanceComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('warrantiesUpdated', this.warrantiesUpdatedHandler);
        window.emitEvent('clearMaintenanceWarrantiesVariables');
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    DialogCreateMaintenanceComponent.prototype.saveMaintenance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var previousMaintenancesWarranties, selectedMaintenanceId, attachmentsMapped, scheduleSuggestionsMapped, maintenance, err_1, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dialogCreateMaintenanceService.hasPreviousMaintenanceWarranties(this.maintenanceForm)];
                    case 1:
                        previousMaintenancesWarranties = _a.sent();
                        if (!previousMaintenancesWarranties) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.shouldContinueWithPreviousWarrantyDialog(previousMaintenancesWarranties)];
                    case 2:
                        selectedMaintenanceId = _a.sent();
                        this.maintenanceForm.get('previousMaintenanceId').setValue(selectedMaintenanceId);
                        _a.label = 3;
                    case 3:
                        this.progressBar.show();
                        this.isLoading = true;
                        return [4 /*yield*/, this.dialogCreateMaintenanceService.toMaintenanceAttachmentsInput(this.maintenanceForm)];
                    case 4:
                        attachmentsMapped = _a.sent();
                        scheduleSuggestionsMapped = this.dialogCreateMaintenanceService.toMaintenanceScheduleSuggestionsInput(this.maintenanceForm);
                        maintenance = this.dialogCreateMaintenanceService.toMaintenanceCreateInput({
                            form: this.maintenanceForm,
                            attachmentsMapped: attachmentsMapped,
                            scheduleSuggestionsMapped: scheduleSuggestionsMapped
                        });
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, 8, 9]);
                        return [4 /*yield*/, this.maintenancesApi.save(maintenance)];
                    case 6:
                        _a.sent();
                        this.matDialogRef.close(true);
                        this.customMessageService.success('MAINTENANCES.CREATE_DIALOG.SUCCESS_MESSAGE');
                        return [3 /*break*/, 9];
                    case 7:
                        err_1 = _a.sent();
                        code = getErrorCode(err_1);
                        if (code === 'maintenance_number_already_exists') {
                            this.maintenanceForm.get('number').setErrors({
                                'maintenanceNumberAlreadyExists': true
                            });
                            return [2 /*return*/];
                        }
                        this.customMessageService.error('MAINTENANCES.CREATE_DIALOG.ERROR_MESSAGE');
                        sentry.captureException(err_1);
                        return [3 /*break*/, 9];
                    case 8:
                        this.progressBar.hide();
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    DialogCreateMaintenanceComponent.prototype.subscribeToSegment = function () {
        var _this = this;
        this.maintenanceForm.get('segment').valueChanges
            .subscribe(function (value) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.maintenanceForm.get('equipments').patchValue([]);
                        this.maintenanceForm.get('locationSectors').patchValue([]);
                        this.maintenanceForm.get('locationEnvironments').patchValue([]);
                        if (!value) {
                            this.maintenanceForm.get('maintenanceType').setValue(null);
                            this.maintenanceForm.get('maintenanceType').disable();
                            return [2 /*return*/];
                        }
                        this.maintenanceForm.get('maintenanceType').enable();
                        _a = this;
                        return [4 /*yield*/, this.segmentsApi.searchOne(value.id)];
                    case 1:
                        _a.selectedSegment = (_b.sent());
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DialogCreateMaintenanceComponent.prototype.subscribeToProblem = function () {
        var _this = this;
        merge(this.maintenanceForm.get('segment').valueChanges, this.maintenanceForm.get('maintenanceType').valueChanges).pipe(takeUntil(this.removeSubscriptions), switchMap(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var where;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        where = {};
                        if (this.maintenanceForm.get('segment').value) {
                            where['segmentId_in'] = mapId(this.maintenanceForm.get('segment').value);
                        }
                        if (this.maintenanceForm.get('maintenanceType').value) {
                            where['maintenanceTypeId_in'] = mapId(this.maintenanceForm.get('maintenanceType').value);
                        }
                        return [4 /*yield*/, this.problemsApi.searchProblems({
                                where: tslib_1.__assign({}, where, { archived: false })
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); })).subscribe(function (problems) {
            if (!problems) {
                return;
            }
            _this.problems = problems;
            if (!_this.maintenanceForm.get('segment').value && !_this.maintenanceForm.get('maintenanceType').value) {
                _this.maintenanceForm.get('problem').setValue(null);
                _this.maintenanceForm.get('problem').disable();
            }
            else {
                _this.maintenanceForm.get('problem').enable();
            }
            var isProblemsOnList = _this.problems.some(function (problem) {
                return _this.maintenanceForm.get('problem').value ? problem.id === _this.maintenanceForm.get('problem').value.id : false;
            });
            if (_this.maintenanceForm.get('problem').value && !isProblemsOnList) {
                _this.maintenanceForm.get('problem').setValue(null);
            }
            if (problems.length && _this.isProblemRequired) {
                _this.maintenanceForm.get('problem').setValidators(Validators.required);
                _this.maintenanceForm.get('problem').updateValueAndValidity();
            }
            else {
                _this.maintenanceForm.get('problem').clearValidators();
                _this.maintenanceForm.get('problem').updateValueAndValidity();
            }
        });
    };
    DialogCreateMaintenanceComponent.prototype.subscribeToCompany = function () {
        var _this = this;
        merge(this.maintenanceForm.get('segment').valueChanges, this.maintenanceForm.get('maintenanceType').valueChanges, this.maintenanceForm.get('location').valueChanges)
            .pipe(takeUntil(this.removeSubscriptions), filter(function () {
            var hasSegment = Boolean(_this.maintenanceForm.get('segment').value);
            var hasMaintenanceType = Boolean(_this.maintenanceForm.get('maintenanceType').value);
            var hasLocation = Boolean(_this.maintenanceForm.get('location').value);
            var hasNotCompany = Boolean(!_this.maintenanceForm.get('company').value);
            return (hasSegment && hasMaintenanceType && hasLocation && hasNotCompany);
        }), switchMap(function () {
            return _this.companiesApi.getCompanyByConfig({
                maintenanceTypeId: _this.maintenanceForm.get('maintenanceType').value.id,
                segmentId: _this.maintenanceForm.get('segment').value.id,
                locationId: _this.maintenanceForm.get('location').value.id
            });
        }))
            .subscribe(function (company) {
            _this.maintenanceForm.get('company').setValue(company || null);
        });
    };
    DialogCreateMaintenanceComponent.prototype.subscribeToDeadlineContract = function () {
        var _this = this;
        merge(this.maintenanceForm.get('segment').valueChanges, this.maintenanceForm.get('maintenanceType').valueChanges, this.maintenanceForm.get('location').valueChanges)
            .pipe(takeUntil(this.removeSubscriptions), filter(function () {
            var hasSegment = Boolean(_this.maintenanceForm.get('segment').value);
            var hasMaintenanceType = Boolean(_this.maintenanceForm.get('maintenanceType').value);
            var hasLocation = Boolean(_this.maintenanceForm.get('location').value);
            return (hasSegment && hasMaintenanceType && hasLocation);
        }), switchMap(function () {
            return _this.deadlineContractApi.getDeadlineContractByConfig({
                maintenanceTypeId: _this.maintenanceForm.get('maintenanceType').value.id,
                segmentId: _this.maintenanceForm.get('segment').value.id,
                locationId: _this.maintenanceForm.get('location').value.id
            });
        }))
            .subscribe(function (receivedDeadlineContract) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var currentDeadlineContract, receivedDeadlineContractIsDifferentThanCurrent, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.maintenanceForm.get('deadlineContract').enable();
                        if (!receivedDeadlineContract) {
                            return [2 /*return*/];
                        }
                        currentDeadlineContract = this.maintenanceForm.get('deadlineContract').value;
                        if (!currentDeadlineContract) {
                            this.maintenanceForm.get('deadlineContract').setValue(receivedDeadlineContract);
                            return [2 /*return*/];
                        }
                        receivedDeadlineContractIsDifferentThanCurrent = currentDeadlineContract.id !== receivedDeadlineContract.id;
                        if (!receivedDeadlineContractIsDifferentThanCurrent) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.matDialog.open(ConfirmDialogComponent, {
                                data: {
                                    title: this.translateService.instant('MAINTENANCES.DEADLINE_CONTRACT_DIALOG.TITLE'),
                                    message: this.translateService.instant('MAINTENANCES.DEADLINE_CONTRACT_DIALOG.MESSAGE'),
                                    okText: this.translateService.instant('MAINTENANCES.DEADLINE_CONTRACT_DIALOG.OK_TEXT'),
                                    cancelText: this.translateService.instant('MAINTENANCES.DEADLINE_CONTRACT_DIALOG.CANCEL_TEXT')
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        if (!result || !result.confirmed) {
                            return [2 /*return*/];
                        }
                        this.maintenanceForm.get('deadlineContract').setValue(receivedDeadlineContract);
                        return [2 /*return*/];
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    DialogCreateMaintenanceComponent.prototype.subscribeToLocationChanges = function () {
        var _this = this;
        this.maintenanceForm.get('location').valueChanges.pipe(takeUntil(this.removeSubscriptions))
            .subscribe(function () {
            _this.maintenanceForm.get('equipments').setValue([]);
            _this.maintenanceForm.get('locationSectors').setValue([]);
            _this.maintenanceForm.get('locationEnvironments').setValue([]);
            if (_this.maintenanceForm.get('location').value) {
                _this.maintenanceForm.get('address').enable();
                _this.maintenanceForm.get('company').enable();
                _this.maintenanceForm.get('address').setValue(_this.maintenanceForm.get('location').value.address);
                return;
            }
            _this.maintenanceForm.get('address').setValue(null);
            _this.maintenanceForm.get('address').disable();
            _this.maintenanceForm.get('company').disable();
        });
    };
    DialogCreateMaintenanceComponent.prototype.subscribeToWarranties = function () {
        var _this = this;
        this.maintenanceForm.get('equipments').valueChanges.pipe(takeUntil(this.removeSubscriptions))
            .subscribe(function (equipments) {
            if (equipments.length) {
                var hasSomeEquipmentWithWarranty = equipments.some(function (equipment) {
                    var warrantySummary = equipment.warrantySummary;
                    var acceptedWarrantyStatus = [WarrantyStatus.active, WarrantyStatus.extended];
                    return warrantySummary && warrantySummary.status && acceptedWarrantyStatus.includes(warrantySummary.status);
                });
                if (hasSomeEquipmentWithWarranty && !_this.alreadyShownPreviousWarrantyDialog) {
                    _this.shouldContinueWithPreviousWarrantyDialog();
                    _this.alreadyShownPreviousWarrantyDialog = true;
                }
            }
        });
    };
    return DialogCreateMaintenanceComponent;
}());
export { DialogCreateMaintenanceComponent };
